import { useCallback } from 'react';

import { useRedeemCashbackMutation } from '@ocx/graphql';

export type UseRedeemAllureCashbackProps = {
  onCompleted?: () => void;
  onError?: (error: unknown) => void;
};

export const useRedeemAllureCashback = ({ onCompleted, onError }: UseRedeemAllureCashbackProps = {}) => {
  const [redeem, { loading }] = useRedeemCashbackMutation({
    onCompleted,
    onError,
  });

  const redeemCashback = useCallback(async () => {
    const result = await redeem();

    return result.data?.redeemCashback;
  }, [redeem]);

  return { redeemCashback, loading };
};
